/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAIcon20Regular = forwardRef('MediaAudioVolumeAIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.736 1.374C13.601.578 15 1.192 15 2.367v15.266c0 1.175-1.399 1.79-2.264.993L7.707 14H4.25A2.25 2.25 0 0 1 2 11.75v-3.5A2.25 2.25 0 0 1 4.25 6h3.457l5.029-4.626Zm.764 1.335L8.651 7.17a1.25 1.25 0 0 1-.846.331H4.25a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75h3.555c.314 0 .616.118.846.33l4.849 4.46V2.71Z" })));
});
